import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  constructor() {}

  async warningSwal(title: any, text: any, icon: any, onClose?: () => void) {
    return await Swal.fire({
      icon: icon,
      title: title,
      text: text,

      showCancelButton: false,
      confirmButtonColor: helper.dialogConfig.colorButtons.standard,
      showConfirmButton: true,
      confirmButtonText: helper.dialogConfig.buttonLabels.close,
      allowOutsideClick: false,
    });
  }

  handleHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.warningSwal(this.errorTitle, msg, this.errorIcon);
      });
    } else {
      let errorMessage =
        environment.config.customNotifications.generalMessages.error;
      this.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
    }
  }
}
